import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BookTypePage } from '@/features/product/pages/BookTypePage';
import { catalogueNameSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/book-types')({
  validateSearch: catalogueNameSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Book Type">
      <Suspense fallback={<PageLoader />}>
        <BookTypePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
